// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 单页面应用

import {ISDEV, PLATFORMTYPE_QQPIM_ANDOIRD, PLATFORMTYPE_QQPIM_IOS} from '@/env'
import aiPhoneData from '@/utils/shouji.js'
import jsbridge from '@/jsbridge'
import lubanApi from '@/lubanApi'
import util from '@/utils/util'
import {SERVICE_SWITCH} from '@/utils/const'

const TAG = 'AppData'

var globalData = {
  isSync: false,
  ISDEV,
  accountId: null,
  tryToBindNum: null,
  guid: null,
  uin: null,
  token: null, // 管家token
  accountName: null,
  accountFaceUrl: null,
  needRelogin: false,
  showNotification: true,
  platform: 'android',

  // 下面数据参考小程序
  needLogin: false,
  loginReady: false,
  loginGjReady: false,
  vipInfoReady: false,
  userSettingReady: false,
  calledListReady: false,
  userCustomContentReady: false,
  userInfo: {
    nickname: '未知用户',
    avatar: '/assets/called.png'
  },
  glBaseData: {
    accountId: '',
  },
  vipInfo: {
    vipStatus: 0,
    expireTime: 0,
    isLimit: 1,
    limit: {
      cnt: 0
    }
  },
  hasRefreshUserSettingFromLogining: false,
  userSetting: {
    openSuccess: true,
    outsideReminder: true,
    phoneNum: '',
    platformType: 3,
    sendMsgNotify: true,
    switchState: 0,
    voiceRole: 1,
    servingNumInvalid: false,
    newServingNum: '', // 废弃
    servingNum: {}
  },
  bannerList: [],
  needRefreshCalledList: false, // 是否需要熟悉列表，比如重新设置了呼叫转移号码
  calledList: {
    isFinished: true,
    recordList: [],
    result: 0,
    totalRecord: 0,
    totalTime: 0
  },
  userCustomContent: {
    firstTalk: '',
  },
  vipProds: null,
  sysInfo: null,
  menuButtonInfo: null,
  aiPhoneNum: '',
  mobileServer: aiPhoneData.mobileServer,
  callAiPhoneNum: '',
  extData: null,
  newPushMsg: false,
  newPushMsgAccept: false,
  newyear: false,
  subMsgTmpids: ['jfbV5b3htstemh7c6AzQG9vpHE_bOYA1ffaVo0wOeUA'],
  starInfos: [],
  activitySelfUserInfo: {},
  fromchannel: null,
  sceneReplySettings: {},
}

var tagSearchNums = new Set()
var tagMap = new Map()

var contactSearchNums = new Set()
var contactMap = new Map()

const ls = window.sessionStorage
const localStorage = window.localStorage
const APP_DATA_KEY = 'appData'
// 如果session中有数据，用session中的数据
{
  var appDataLsStr = ls.getItem(APP_DATA_KEY)
  console.log('appDataLsStr ' + appDataLsStr)
  if (appDataLsStr != null && appDataLsStr != undefined) {
    try {
      globalData = JSON.parse(appDataLsStr)
      console.log('load ls globalData ')
    } catch (err) {
      console.log(err)
    }
  }
}

// ---------------------------新增方法-------------------------------
function getData () {
  return globalData
}

function setData (key, value) {
  globalData[key] = value
  console.log('setData', key, value)
}

function initBaseData (refresh, fromLogin = false) {
  console.log('initBaseData', refresh, fromLogin)
  if (globalData.hasRefreshUserSettingFromLogining) {
    refresh = false
    globalData.hasRefreshUserSettingFromLogining = false
  }
  return new Promise((resolve, reject) => {
    if (!globalData.accountId) {
      console.log('reject initBaseData ', globalData.accountId)
      reject()
      return
    }

    Promise.all([getVipInfoWithLimit(refresh), lubanApi.getUserSetting(refresh)])
      .then(infoRes => {
        console.log('infoRes ', infoRes)
        let vipInfoRes = infoRes[0]
        let userSettingRes = infoRes[1]
        vipInfoRes && setVipInfo(vipInfoRes)
        userSettingRes && setUserSetting(userSettingRes)

        setHasLogined()
        resolve()
        if (fromLogin) {
          globalData.hasRefreshUserSettingFromLogining = true
        }
      }).catch(err => {
        reject(err)
      })
  })
}

// 暂不考虑后台记录limit条数
function getVipInfoWithLimit (refresh) {
  return new Promise((resolve, reject) => {
    jsbridge.getVipInfo(refresh).then(vipinfo => {
      resolve(vipinfo)
      // if(vipinfo.vipStatus == 1){
      //   resolve(vipinfo)
      // }else{
      //   lubanApi.getVipInfoWithLimit().then( res => {
      //     console.log(TAG, 'getVipInfoWithLimit', res)
      //     if(res.data.code == 0){
      //       vipinfo.limit = res.data.data
      //     }
      //     resolve(vipinfo)
      //   }).catch(err => {
      //     resolve(vipinfo)
      //   })
      // }
    })
  })
}

function updateVipLimit () {
  return lubanApi.updateVipLimit()
}

function getCalledList (startTime = Date.now(), loadMore = false) {
  return new Promise((resolve, reject) => {
    lubanApi.getCalledList(startTime).then(res => {
      resolve(res)
      globalData.calledListReady = true
      // loadmore 追加记录
      if (loadMore) {
        let newRecordList = globalData.calledList.recordList.concat(res.recordList)
        globalData.calledList.recordList = newRecordList
        globalData.needRefreshCalledList = false
      } else {
        globalData.calledList = res
        if (globalData.calledList.totalRecord < 3) {
          jsbridge.setLeftTryTimes(3 - globalData.calledList.totalRecord)
        } else {
          jsbridge.setLeftTryTimes(0)
        }
      }
      saveData()
    }).catch(err => {
      reject(err)
    })
  })
}

function reportCallRead (sessionId) {
  return new Promise((resolve, reject) => {
    lubanApi.reportCallRead(sessionId).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

function reportProfile () {
  return lubanApi.reportProfile()
}

function setVipInfo (info) {
  globalData.vipInfoReady = true
  globalData.vipInfo = Object.assign({}, globalData.vipInfo || {}, info)
  console.log(TAG, 'setVipInfo', info)
}

function setUserSetting (settingData) {
  globalData.userSettingReady = true
  globalData.userSetting = Object.assign({}, globalData.userSetting || {}, settingData || {})
  updateGuid()
}

function updateGuid () {
  if (!util.isEmpty(globalData.userSetting.phoneNum) && !util.isEmpty(globalData.guid)) {
    if (globalData.userSetting.pushKey === globalData.guid) {
      console.log(TAG, 'updateGuid', 'equal')
    } else {
      console.log(TAG, 'updateGuid', 'update', globalData.userSetting.pushKey, globalData.guid)
      globalData.userSetting.pushKey = globalData.guid
      globalData.userSetting.platformType = getPlatFormType()
      reportProfile()
    }
  }
}

function setUserCustomContent (data) {
  globalData.userCustomContentReady = true
  globalData.userCustomContent = Object.assign({},
    globalData.userCustomContent || {},
    data || {})
}

function getOpeningRemark () {
  return new Promise((resolve, reject) => {
    lubanApi.getOpeningRemark().then(res => {
      console.log(res)
      if (res.data.success) {
        resolve(res.data.data.resp)
      } else {
        resolve({
          callName: '',
          firstTalk: '',
          userStatus: ''
        })
      }
    })
  })
}

// firstTalk 不能为空，否则不能设置
function reportCustomContent () {
  let {userStatus, firstTalk, callName} = globalData.userCustomContent
  console.log({userStatus, firstTalk, callName})
  return lubanApi.reportCustomContent(userStatus, firstTalk, callName)
}

/**
 * 很多地方都需要判断是否是会员，
 * 这里提供个方便的接口
 */
function isVip () {
  if (globalData.vipInfo &&
    globalData.vipInfo.vipStatus === 1) {
    return true
  } else {
    return false
  }
}

function isLimitRead () {
  if (isVip()) {
    return false
  } else if (globalData.calledList != null && globalData.calledList.totalRecord > 3) {
    return true
  } else {
    return false
  }
}

function getCallForwardNum (refresh) {
  return new Promise((resolve, reject) => {
    lubanApi.getUserSetting(refresh).then(res => {
      res && setUserSetting(res)
      resolve(util.getCallForwardNum())
    }).catch(err => {
      console.log(TAG, 'getCallForwardNum', err)
      resolve(util.getCallForwardNum())
    })
  })
}

function getTagPhonenum (nums) {
  return lubanApi.getTagPhonenum(nums)
}

function fetchSceneReplyData () {
  console.log('fetchSceneReplyData')
  return new Promise(((resolve, reject) => {
    lubanApi.fetchSceneReplyData(globalData.userSetting.phoneNum).then(
      value => {
        console.log('fetchSceneReplyData success')
        console.log(JSON.stringify(value))
        let success = value.statusCode == 200 &&
          value.data &&
          value.data.data &&
          value.data.data.res &&
          value.data.data.res.resp &&
          value.data.data.res.resp.retCode === 0
        if (success) {
          resolve(value.data.data.res.resp.sceneCustomizeScriptMap)
        } else {
          reject({})
        }
      }, reason => {
        console.log('fetchSceneReplyData fail')
        console.log(JSON.stringify(reason))
        reject(reason)
      }
    ).catch(e => {
      reject(e)
    })
  }))
}

function updateSceneReply () {
  console.log('fetchSceneReplyData')
  console.log(globalData.userSetting.phoneNum)
  console.log(globalData.sceneReplySettings)
  return new Promise(((resolve, reject) => {
    lubanApi.updateSceneReply(
      globalData.userSetting.phoneNum,
      globalData.sceneReplySettings).then(value => {
      resolve(value)
    }, reason => {
      reject(reason)
    }).catch(e => {
      reject(e)
    })
  }))
}

function setSceneReplyData (data) {
  globalData.sceneReplySettings = Object.assign({},
    globalData.sceneReplySettings || {},
    data || {})
}

// 两次刷新
function updateCallListTag () {
  return new Promise((resolve, reject) => {
    var s = []
    globalData.calledList.recordList.forEach(item => {
      // console.log(TAG, 'item', item)
      var callerPhoneNum = item.callKey.callerPhoneNum
      if (!util.isEmpty(callerPhoneNum)) {
        if (!tagSearchNums.has(callerPhoneNum)) {
          s.push(callerPhoneNum)
          tagSearchNums.add(callerPhoneNum)
        }
      }
    })
    console.log(TAG, s)
    if (s.length > 0) {
      lubanApi.getTagPhonenum(s).then(res => {
        console.log(TAG, 'getTagPhonenum', res)
        console.log(TAG, 'getTagPhonenum', res.data.code)
        console.log(TAG, 'getTagPhonenum', res.data.data.resp)
        console.log(TAG, 'getTagPhonenum', res.data.data.resp.vecTagTel)
        console.log(TAG, 'getTagPhonenum', res.data.data.resp.vecTagTel.length)
        if (res.data.code === 0 && res.data.data.resp.vecTagTel.length > 0) {
          console.log(TAG, 'vecTagTel')
          // 先刷新map
          for (let vecTag of res.data.data.resp.vecTagTel) {
            let tagType = vecTag.tagType // 标记类型
            let phoneName = vecTag.phoneName // 黄页名

            if (tagType > 0 || phoneName) {
              tagMap.set(vecTag.phoneNum, {
                tagType: tagType,
                phoneName: phoneName
              })
            }
          }
          // 然后刷新列表数据
          globalData.calledList.recordList.forEach(item => {
            var callerPhoneNum = item.callKey.callerPhoneNum
            if (tagMap.has(callerPhoneNum)) {
              item.mark = tagMap.get(callerPhoneNum)
            }
          })
          resolve()
        } else {
          reject()
        }
      }).catch(err => {
        reject(null)
      })
    } else {
      reject()
    }
  })
}

// 两次刷新
function updateCallListContacts () {
  return new Promise((resolve, reject) => {
    var s = []
    globalData.calledList.recordList.forEach(item => {
      // console.log(TAG, 'item', item)
      var callerPhoneNum = item.callKey.callerPhoneNum
      if (!util.isEmpty(callerPhoneNum)) {
        if (!contactSearchNums.has(callerPhoneNum)) {
          s.push(callerPhoneNum)
          contactSearchNums.add(callerPhoneNum)
        }
      }
    })

    console.log(TAG, 'updateCallListContacts', s)
    if (s.length > 0) {
      jsbridge.searchNums(s).then(res => {
        console.log(TAG, 'searchContactNums', res)
        // alert('updateCallListContacts' + JSON.stringify(res.nums.length))
        if (res.nums != undefined && res.nums.length > 0) {
          for (let contactInfo of res.nums) {
            contactMap.set(contactInfo.num, contactInfo)
          }

          // 然后刷新列表数据
          globalData.calledList.recordList.forEach(item => {
            var callerPhoneNum = item.callKey.callerPhoneNum
            if (contactMap.has(callerPhoneNum)) {
              item.contactInfo = contactMap.get(callerPhoneNum)
            }
          })
        }

        resolve()
      }).catch(err => {
        reject(null)
      })
    } else {
      reject()
    }
  })
}

let hasLoggined = false

function setHasLogined () {
  hasLoggined = true
}

function isLogined () {
  return hasLoggined
}

function putLocalStorage (key, value) {
  localStorage.setItem(key, value)
  if (key === SERVICE_SWITCH.NAME) {
    jsbridge.setServiceSwitch(value)
  }
}

function getLocalStorage (key) {
  return localStorage.getItem(key)
}

function setNeedRefreshCalledList (refresh) {
  globalData.needRefreshCalledList = refresh
}

function setNeedRelogin (relogin) {
  globalData.needRelogin = relogin
}

function setShowNotification (show) {
  globalData.showNotification = show
}

function setPlatform (platform) {
  globalData.platform = platform
  if (platform) {
    putLocalStorage('platform', platform)
  }
}

function getPlatFormType () {
  if ((globalData.platform && globalData.platform.toLowerCase() === 'ios') || (getLocalStorage('platform') && getLocalStorage('platform').toLowerCase() == 'ios')) {
    return PLATFORMTYPE_QQPIM_IOS
  } else {
    return PLATFORMTYPE_QQPIM_ANDOIRD
  }
}

export default {
  getData,
  setData,
  initBaseData,
  getCalledList,
  reportCallRead,
  reportProfile,
  getOpeningRemark,
  reportCustomContent,
  setUserCustomContent,
  isVip,
  isLimitRead,
  getCallForwardNum,
  fetchSceneReplyData,
  updateSceneReply,
  setSceneReplyData,
  isLogined,
  putLocalStorage,
  getLocalStorage,
  updateVipLimit,
  getTagPhonenum,
  updateCallListTag,
  updateCallListContacts,
  setNeedRefreshCalledList,
  setNeedRelogin,
  setShowNotification,
  setVipInfo,
  setPlatform,
  getVipInfoWithLimit,
  getPlatFormType
}



// WEBPACK FOOTER //
// ./src/AppData.js